import axios from 'axios'
import { useEffect, useState } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'

export const useChatHistory = (id: string | number | undefined) => {}

export const useChatMessages = (
  phoneNumber: string | number | undefined,
  agentPhoneNumber: string | number | undefined,
) => {
  const phoneNo = phoneNumber?.toString().replace(/\D/g, '').replace(/^1/, '')
  const endPoint = `${process.env.REACT_APP_CONTACT_CENTER_MICROSERVICE_URL}messages/thread/?phoneNo=${phoneNo}`

  const { data } = useQuery(
    ['list-messages', phoneNumber],
    async () => {
      const response = await axios.get(endPoint)
      return response?.data
    },
    {
      enabled: !!phoneNo,
      refetchInterval: 3000,
    },
  )

  if (!phoneNumber && !agentPhoneNumber) return []

  if (!!data?.length === false) return []

  return data.map(chat => {
    const isContact = chat.messageType === 'RECEIVER' ? false : true

    return {
      text: chat.text,
      from: isContact ? 'contact' : 'agent',
    }
  })

  /* return [
    {
      text: 'this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message',
      from: 'contact',
    },
    {
      text: 'this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message',
      from: 'agent',
    },
    {
      text: 'this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message',
      from: 'agent',
    },
    {
      text: 'this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message',
      from: 'agent',
    },
    {
      text: 'this is received message',
      from: 'contact',
    },
    {
      text: 'this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message',
      from: 'contact',
    },
    {
      text: 'this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message',
      from: 'agent',
    },
    {
      text: 'this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message this is sent message',
      from: 'agent',
    },
  ] */
}

export const useSendMessage = () => {
  const queryClient = useQueryClient()

  const endPoint = `${process.env.REACT_APP_TWILIO_MICROSERVICE_URL}send-message/`

  return useMutation(
    (payload: any) => {
      return axios.post(endPoint, payload)
    },
    {
      onSettled: (response: any) => {
        queryClient.invalidateQueries(['list-messages', response?.to?.replace(/\D/g, '').replace(/^1/, '')])
        queryClient.invalidateQueries(['list-messages', response?.from?.replace(/\D/g, '').replace(/^1/, '')])
      },
    },
  )
}

export const useChatSSEMessages = (
  phoneNumber: string | number | undefined,
  agentPhoneNumber: string | number | undefined,
) => {
  const phoneNo = phoneNumber?.toString().replace(/\D/g, '').replace(/^1/, '')
  const [data, setData] = useState<any>([])
  const eventURL = `${process.env.REACT_APP_CONTACT_CENTER_MICROSERVICE_URL}sse/messages/thread/?phoneNo=${phoneNo}`

  useEffect( () => {
    setData([]);
  }, [phoneNo] );

  useEffect(() => {
    const eventSource = new EventSource(eventURL)
    const event = eventSource.addEventListener('messages-event', (event: any) => {
      setData(JSON.parse(event.data))
    })
    return () => {
     
      
      eventSource.close()
      eventSource.removeEventListener('messages-event' as any, event as any)
     
      console.log("Closing Event Source: " + phoneNo + " : " + eventSource.readyState)
      console.log( "Closing Code: ", EventSource.CLOSED )
    }
  }, [phoneNo])

  return data.map(chat => {
    const isContact = chat.messageType === 'RECEIVER' ? false : true

    return {
      text: chat.text,
      from: isContact ? 'contact' : 'agent',
    }
  })
}
